import React, {Component} from 'react';
import {connect} from 'react-redux';
import './css/Profile.styl';
import Carousel from './components/Carousel';
import TabsComp from './components/Tabs';
import Aside from './components/Aside';
import FuneralInfo from './components/FuneralInfo';
import TopLeaderboardAdOptions from './components/Shared/TopLeaderboardAdOptions';
import {
  setCookie,
  getCookie,
  getAspCookieSubValue,
} from '../../shared/utilities/cookies';
import {buildAffiliateUrl} from '../../shared/utilities/urlHelpers';
import {AFFILIATE_COOKIE} from '../../shared/utilities/constants';
import Breadcrumbs from './components/Shared/Breadcrumbs';
import MobileOverlayAd from './components/Shared/MobileOverlayAd';
import withMediaQuery from './components/Shared/WithMediaQuery';
import CtaModule from './components/Shared/CtaModule';

export class Profile extends Component {
  static propTypes = {
    ads: React.PropTypes.object.isRequired,
    affiliate: React.PropTypes.object,
    funeralHome: React.PropTypes.object.isRequired,
  };

  componentDidMount() {
    // If the affiliate that is associated to this profile page request
    // is not cookied, set the Legacy Global Affiliate Cookie for the user
    if (this.props.affiliate) {
      this.setAffiliateCookie();
    }
  }

  setAffiliateCookie() {
    const {sourceId: affiliateId, siteName} = this.props.affiliate;

    if (affiliateId) {
      const affiliateCookie = getCookie(AFFILIATE_COOKIE.name);
      const currentCookiedAffiliateId = getAspCookieSubValue(
        affiliateCookie,
        AFFILIATE_COOKIE.idKey
      );

      if (currentCookiedAffiliateId !== `${affiliateId}`) {
        const cookieSubValues = [
          `${AFFILIATE_COOKIE.idKey}=${affiliateId}`,
          `${AFFILIATE_COOKIE.siteNameKey}=${siteName}`,
          `${AFFILIATE_COOKIE.urlKey}=${buildAffiliateUrl(siteName)}`,
        ];

        setCookie(AFFILIATE_COOKIE.name, cookieSubValues.join('&'), 4 / 24);
      }
    }
  }

  render() {
    const {matches: mqMatches} = this.props;
    const funeralHome = this.props.funeralHome;
    const {isPremium, adData: {displayOverlayOnMobile} = {}} = funeralHome;
    const entityBreadcrumbs = {
      name: funeralHome.name,
      location: funeralHome.location,
    };

    return (
      <div className="funeral-home-profile">
        <div className="funeral-home-profile-content">
          <div className="head-container">
            <Breadcrumbs entity={entityBreadcrumbs} />
            {!isPremium && (
              <TopLeaderboardAdOptions adService={this.props.ads.adService} />
            )}
          </div>
          {isPremium && <Carousel />}
          <main className="main-container">
            <div className="left-side">
              <FuneralInfo funeralHome={this.props.funeralHome} />
              {mqMatches && <CtaModule />}
              <TabsComp funeralHome={this.props.funeralHome} />
            </div>
            <Aside />
          </main>
          {!isPremium && displayOverlayOnMobile && (
            <MobileOverlayAd positionId="display-overlay-1" />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  ads: state.adStore,
  affiliate: state.affiliateStore,
  funeralHome: state.funeralHomeStore,
});

export default connect(mapStateToProps)(
  withMediaQuery(Profile, {mediaQuery: '(max-width: 900px)'})
);



// WEBPACK FOOTER //
// ./src/reactModules/pages/Profile/index.js